// src/store/slices/dashboardSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

export const fetchDashboardSummaryThunk = createAsyncThunk(
  "dashboard/fetchSummary",
  async (_, { rejectWithValue, signal }) => {
    try {
      const res = await api.get("/api/dashboard/summary", { signal });

      if (!res.data?.success) {
        return rejectWithValue(res.data?.message || "Failed");
      }

      return res.data.data;
    } catch (e) {
      // axios cancel
      if (e?.name === "CanceledError" || e?.code === "ERR_CANCELED") {
        return rejectWithValue("REQUEST_CANCELLED");
      }

      const msg = e?.response?.data?.message || e.message || "Server error";

      // when switching fast, backend may say headers missing for a moment
      if (String(msg).includes("x-pan-id") || String(msg).includes("x-pan-ids")) {
        return rejectWithValue("TENANT_NOT_READY");
      }

      return rejectWithValue(msg);
    }
  }
);

const slice = createSlice({
  name: "dashboard",
  initialState: {
    data: null,
    loading: false,
    error: null,
    currentRequestId: undefined,
  },
  reducers: {
    resetDashboard(state) {
      state.data = null;
      state.loading = false;
      state.error = null;
      state.currentRequestId = undefined;
    },
  },
  extraReducers: (b) => {
    b.addCase(fetchDashboardSummaryThunk.pending, (state, action) => {
      state.loading = true;
      state.error = null;
      state.currentRequestId = action.meta.requestId;
    });

    b.addCase(fetchDashboardSummaryThunk.fulfilled, (state, action) => {
      // ✅ IGNORE old response
      if (state.currentRequestId !== action.meta.requestId) return;

      state.loading = false;
      state.data = action.payload;
      state.error = null;
      state.currentRequestId = undefined;
    });

    b.addCase(fetchDashboardSummaryThunk.rejected, (state, action) => {
      // ✅ IGNORE old response
      if (state.currentRequestId !== action.meta.requestId) return;

      state.loading = false;
      state.currentRequestId = undefined;

      // ✅ ignore non-user-visible errors
      if (action.payload === "REQUEST_CANCELLED" || action.payload === "TENANT_NOT_READY") {
        return;
      }

      state.error = action.payload || "Failed";
    });
  },
});

export const { resetDashboard } = slice.actions;
export default slice.reducer;
